(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vantrek-ai-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vantrek-ai-guide')) customElements.define('vantrek-ai-guide', class extends HTMLElement {
  connectedCallback() {
    if(this.ready) return; this.ready = true;
    const launcher=this.querySelector('.vr-ai-launcher'), panel=this.querySelector('.vr-ai-panel'), close=this.querySelector('.vr-ai-close');
    const setOpen=(open)=>{panel.hidden=!open;launcher.setAttribute('aria-expanded',String(open));if(open) panel.querySelector('select, input')?.focus();else launcher.focus();};
    launcher.addEventListener('click',()=>setOpen(panel.hidden));
    close.addEventListener('click',()=>setOpen(false));
    this.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&!panel.hidden)setOpen(false);});
    this.querySelector('form').addEventListener('submit', async (event) => {
      event.preventDefault();
      const form=event.currentTarget, button=form.querySelector('button'), result=this.querySelector('.vr-ai-results');
      const original=button.textContent;
      button.disabled=true; button.textContent=this.dataset.wait; result.replaceChildren();
      try {
        const fields=new FormData(form);
        const brief={industry:fields.get('industry'),useCase:fields.get('useCase'),teamSize:Number(fields.get('teamSize')),budget:fields.get('budget')};
        const response=await fetch('https://teamorder.vantrek.com.au/api/home-sales-guide',{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({brief}),signal:AbortSignal.timeout(45000)});
        if(!response.ok) throw new Error(response.status===429?this.dataset.rate:this.dataset.error);
        const payload=await response.json();
        const heading=document.createElement('h3'); heading.textContent=payload.provider==='OPENAI'?this.dataset.ai:this.dataset.rules;
        const summary=document.createElement('p'); summary.textContent=payload.summary;
        const cards=document.createElement('div'); cards.className='vr-ai-cards';
        for(const product of (Array.isArray(payload.products)?payload.products.slice(0,3):[])) {
          if(!/^[a-z0-9][a-z0-9-]*$/.test(product.handle)) continue;
          const card=document.createElement('a'); card.href=window.Shopify.routes.root+'products/'+encodeURIComponent(product.handle);
          const title=document.createElement('strong'); title.textContent=product.title;
          const vendor=document.createElement('small'); vendor.textContent=product.vendor;
          card.append(vendor,title);
          if(product.price&&Number.isFinite(Number(product.price.amount))) {const price=document.createElement('span'); price.textContent=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(Number(product.price.amount))+' AUD';card.append(price);}
          cards.append(card);
        }
        result.append(heading,summary,cards);
      } catch(error) { result.textContent=error.message===this.dataset.rate?this.dataset.rate:this.dataset.error; }
      finally {button.disabled=false;button.textContent=original;}
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vantrek-legacy-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vantrek-legacy-search')) customElements.define('vantrek-legacy-search', class extends HTMLElement {
  connectedCallback() {
    const query = new URLSearchParams(window.location.search).get('q');
    if (!query || !query.trim()) return;
    const target = new URL(window.Shopify.routes.root + 'search', window.location.origin);
    target.searchParams.set('type', 'product');
    target.searchParams.set('q', query);
    window.location.replace(target.href);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vantrek-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vantrek-size-guide'))customElements.define('vantrek-size-guide',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('dialog'),trigger=this.querySelector('.vr-size-trigger');trigger.addEventListener('click',()=>dialog.showModal());this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>trigger.focus());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});const source=this.querySelector('[data-size-data]');if(source){const d=JSON.parse(source.textContent);this.querySelector('[data-measurements]').textContent=[...(d.sizingLines||[]),d.productDimensions||''].filter(Boolean).join('\n');this.querySelector('[data-source]').textContent=[d.source,d.updatedAt].filter(Boolean).join(' · ');if(d.sourceUrl&&/^https:\/\//.test(d.sourceUrl)){const a=this.querySelector('[data-official]');a.href=d.sourceUrl;a.hidden=false;}}}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vantrek-team-matrix"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vantrek-team-matrix')) {
  customElements.define('vantrek-team-matrix', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.s = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.panel = this.querySelector('[data-panel]');
      this.status = this.querySelector('[data-status]');
      this.submit = this.querySelector('[data-submit]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency,currencyDisplay:'code'});
      this.querySelector('[data-toggle]').addEventListener('change', async e => {
        this.panel.hidden = !e.target.checked;
        if (e.target.checked && !this.loaded && !this.loading) await this.load();
      });
      this.querySelector('[data-clear]').addEventListener('click', () => { this.querySelectorAll('input[data-variant]').forEach(x => x.value = '0'); this.status.textContent = ''; this.update(); });
      this.querySelector('form').addEventListener('input', () => this.update());
      this.querySelector('form').addEventListener('submit', e => {e.preventDefault(); this.add();});
      this.update();
    }
    async load() {
      this.loading = true;
      this.status.textContent = this.s.loading;
      try {
        const response = await fetch(this.dataset.productUrl + '.js');
        if (!response.ok) throw new Error();
        const p = await response.json();
        const ci = p.options.findIndex(o => /^(colou?r)$/i.test(o.name));
        const si = p.options.findIndex(o => /^size$/i.test(o.name));
        if (ci < 0 || si < 0 || p.options.length !== 2 || p.variants.length >= 250) throw new Error();
        const head = this.querySelector('thead');
        const tr = document.createElement('tr');
        [this.s.colour,...p.options[si].values].forEach(label => {const th = document.createElement('th');th.scope='col';th.textContent=label;tr.append(th);});
        head.replaceChildren(tr);
        const body = this.querySelector('tbody');
        body.replaceChildren();
        p.options[ci].values.forEach(colour => {
          const row = document.createElement('tr');
          const th = document.createElement('th');th.scope='row';
          const label = document.createElement('span');label.className='vtm-colour';
          const first = p.variants.find(v => v.options[ci] === colour);
          if (first?.featured_image?.src) {const img=document.createElement('img');img.src=first.featured_image.src;img.alt='';img.loading='lazy';img.width=34;img.height=44;label.append(img);}
          label.append(document.createTextNode(colour));th.append(label);row.append(th);
          p.options[si].values.forEach(size => {
            const variant=p.variants.find(v=>v.options[ci]===colour&&v.options[si]===size);
            const td=document.createElement('td');const input=document.createElement('input');
            input.type='number';input.min='0';input.step='1';input.value='0';input.inputMode='numeric';
            input.setAttribute('aria-label',`${colour}, ${size} — ${this.s.quantity}`);
            if (!variant?.available) {input.disabled=true;input.value='';input.placeholder='—';input.title=this.s.unavailable;}
            else {input.dataset.variant=variant.id;input.dataset.price=variant.price;}
            td.append(input);row.append(td);
          });
          body.append(row);
        });
        this.loaded=true;this.status.textContent='';this.update();
      } catch {this.status.textContent=this.s.error;} finally {this.loading=false;}
    }
    update() {
      let count=0,total=0;
      this.querySelectorAll('input[data-variant]').forEach(x=>{const q=Number(x.value);if(Number.isSafeInteger(q)&&q>0){count+=q;total+=q*Number(x.dataset.price);}});
      this.querySelector('[data-count]').textContent=count;
      this.querySelector('[data-total]').textContent=this.money.format(total/100);
      this.submit.disabled=count<Number(this.dataset.minOrder||1)||this.busy;
    }
    async add() {
      if(this.busy)return;
      const notes=this.querySelector('textarea').value.trim();
      const items=Array.from(this.querySelectorAll('input[data-variant]')).filter(x=>Number(x.value)>0).map(x=>({id:Number(x.dataset.variant),quantity:Number(x.value),...(notes?{properties:{[this.s.notes]:notes}}:{})}));
      if(items.reduce((sum,item)=>sum+item.quantity,0)<Number(this.dataset.minOrder||1)){this.status.textContent=this.s.empty;return;}
      this.busy=true;this.update();this.submit.textContent=this.s.adding;this.status.textContent='';
      try {
        const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok){this.status.textContent=result.description||this.s.error;return;}
        window.location.assign(window.Shopify.routes.root+'cart');
      } catch {this.status.textContent=this.s.error;} finally {this.busy=false;this.submit.textContent=this.s.add;this.update();}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
